import React, { useState, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';
import { StatisticDataVO } from '@/types/camp/admin/statisticDataType';
import NoData from '@/components/noData';

interface Props {
  data?: StatisticDataVO;
}
const EchartsBarNodes: React.FC<Props> = ({ data }) => {
  const [options, setOptions] = useState<{}>();
  const [valueList, setValueList] = useState<string[]>();
  const [totalList, setTotalList] = useState<any[]>();
  const [dataHeight, setDataHeight] = useState<number>(0);

  useEffect(() => {
    let newArr = data?.funnelData.map((student) => {
      return student.name;
    });
    const newData = data?.funnelData.map((item) => ({
      value: ((item.countSuccessNode / data.studyNodeNum) * 100).toFixed(2),
      name: item.name,
      info: item.countSuccessNode,
    }));

    setValueList(newArr);
    setTotalList(newData);
  }, [data?.funnelData]);

  useEffect(() => {
    const option = {
      // tooltip: {
      //   trigger: 'item',
      //   formatter: '{b}',
      // },

      legend: {
        data: valueList,
      },
      series: [
        {
          type: 'funnel',
          left: 14,
          top: 66,
          bottom: 6,
          width: '98%',
          min: 0,
          max: 100,
          minSize: '1%',
          maxSize: '100%',
          sort: 'none',
          gap: 0,
          label: {
            show: true,
            position: 'inside',
            formatter: function (params: any) {
              return `${params.name}\n\n${params.data.value}%  ${params.data.info}`;
            },
            emphasis: {
              fontSize: 14,
            },
          },
          labelLine: {
            length: 10,
            lineStyle: {
              width: 1,
              type: 'solid',
            },
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 0,
          },
          data: totalList,
        },
      ],
    };
    data && setDataHeight(data?.funnelData.length * 86);
    setTimeout(function () {
      setOptions(option);
    }, 500);
    console.log('totalList', totalList);
  }, [data?.funnelData, valueList]);

  return (
    <div className="com_cmap_card_box" style={{ height: '100%', overflow: 'hidden' }}>
      <div className="com_card_title16" style={{ marginBottom: 16 }}>
        <span>打卡完成漏斗</span>
      </div>
      {data?.funnelData && data?.studyNodeNum > 0 ? (
        <div>
          {options && (
            <ReactECharts
              option={options}
              style={{ width: 750, minHeight: 500, marginLeft: -14, height: dataHeight }}
            />
          )}
        </div>
      ) : (
        <NoData name="暂无数据" />
      )}
    </div>
  );
};
export default EchartsBarNodes;
